<template>
  <div class="vouchers">
    <div class="smbox">
      <div class="row">
        <div class="col-md-5  col-sm-5 col-5">
          <p class="pl-1 smlink" v-if="!authStatus"><span class="nonlink" @click="$parent.loginBoxModal(applygiftvoucher)">Login to Apply</span>
          </p>
        </div>
      </div>
      <div class="row prelative">
        <div v-if="!$parent.$parent.isDesktop" class="d-flex flex-direction-row col-12 custom-input-parent align-items-center">
          <input
            v-if="voucher_applied || fizzed_out"
            type="text"
            class="custom-input form-control sm"
            disabled
            :value="this.callerComp === 'buyNow' ? buyNow_gift_voucher.voucher_code : giftvoucher.voucher_code"
          >
          <input
            v-else
            type="text" id="gift" class="custom-input form-control sm"
            placeholder="Enter Gift Voucher Code" v-model="giftvouchercode"
          />
          <div class='d-flex justify-content-center' v-if="callerComp === 'buyNow' ? isBuynowVoucherLoading : isVoucherLoading">
            <img :src="staticImgServer + 'assets/spinner-3.gif'" class='coupon-spinner' alt="Loader"/>
          </div>
          <div v-else>
            <span class="custom-input-btn pr-2" v-if="fizzed_out"><i class="fa fa-exclamation redlink"></i></span>
            <span class="custom-input-btn pr-2" v-else-if="voucher_applied" @click="removeVoucher">Remove</span>
            <span class="custom-input-btn pr-2" v-else @click="applygiftvoucher">APPLY</span>
          </div>
        </div>
        <div v-else class="col-md-7  col-sm-7 col-7">
          <input type="text" name="" class="form-control sm" placeholder="Enter Code Here"
                 v-if="voucher_applied || fizzed_out" disabled :value="this.callerComp === 'buyNow' ? buyNow_gift_voucher.voucher_code : giftvoucher.voucher_code">
          <input type="text" name="" class="form-control sm" placeholder="Enter Code Here" v-else v-model="giftvouchercode"
                 id="gift">
        </div>
        <div v-if="$parent.$parent.isDesktop" class="col-md-5  col-sm-5 col-5">
          <button type="button" disabled class="btn btn-outline-info btn-sm form-control text-uppercase"
                  style="height: 30px;" v-if="fizzed_out"><i class="fa fa-exclamation redlink"></i></button>
          <button type="button" disabled class="btn btn-outline-info btn-sm form-control text-uppercase"
                  style="height: 30px;" v-else-if="voucher_applied">Applied</button>
          <button type="button" id="applygiftvoucher" class="btn btn-outline-info btn-sm form-control  text-uppercase"
                  @click="applygiftvoucher" v-else-if="authStatus">Apply
          </button>
        </div>
      </div>
      <p v-if="vouchermsg" class="error"> {{ vouchermsg }}</p>
      <p v-if="errormsg" class="error"> Please Enter Code</p>

      <p v-if="voucher_applied">Voucher code Applied!  <span v-if="$parent.$parent.isDesktop" class="redlink pointer"
                                                             @click="removeVoucher"><u> Remove </u></span></p>
      <!-- CHECK: if this is as expected-->
      <p v-if="fizzed_out">Not Applicable on current Cart <span v-if="$parent.$parent.isDesktop" class="redlink pointer"
                                                                @click="removeVoucher"><u> Remove </u></span></p>
    </div>
    <component :is="gvPinModalData.currentModal" :toggleModal="toggleVoucherPinPopup" :title="'Enter Gift Voucher PIN'">
      <div class="custom-input-parent my-3">
        <input
          type="tel" :maxlength="gvPinModalData.pinMaxLength" class="custom-input form-control sm"
          placeholder="Enter Gift Voucher PIN" v-model="gvPinModalData.giftvoucherPin"
          v-on:keydown="gvPinUpdate($event)"
        />
      </div>
        <div class="d-flex align-items-center my-2">
          <button type="button" id="applygiftvoucherPin"
            class="my-3 mr-2 btn btn-sm btn-outline-info form-control text-uppercase"
            :disabled="gvPinModalData.isPinBtnApplied"
            @click="applyVoucherwithPin">Apply
          </button>
          <button type="button" id="cancelPin"
            class="my-3 ml-2 btn btn-sm btn-outline-info form-control text-uppercase"
            @click="toggleVoucherPinPopup">Cancel
          </button>
        </div>
    </component>
  </div>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import {mapGetters} from 'vuex'
  import Vue from 'vue'

  export default {
    data () {
      return {
        giftvouchercode: '',
        vouchermsg: '',
        errormsg: false,
        successVoucherMsg: false,
        errorInvalidVoucher: false,
        applybtn: true,
        giftTotal: this.uptotal,
        giftgst: this.upgst,
        giftAmt: this.gvoucher,
        staticImgServer: process.env.STATIC_IMG_SERVER2,
        gvPinModalData: {
          currentModal: null,
          giftvoucherPin: null,
          isPinError: false,
          pinMaxLength: 6,
          pinDefErrorMsg: 'Limit Exceeded, Please try again later'
        }
      }
    },
    components: {
      'popup-modal': () => import('@/components/common/popupModal.vue')
    },
    props: ['callerComp'],
    methods: {
      applygiftvoucher () {
        if (this.authStatus) {
          this.vouchermsg = ''
          if (this.giftvouchercode === '') {
            this.vouchermsg = false
            this.successVoucherMsg = false
            this.errormsg = true
            return false
          }
          this.errormsg = false
          if (this.callerComp === 'buyNow') {
            this.$store.dispatch('APPLY_BUYNOW_GIFT_VOUCHER', {voucher_code: this.giftvouchercode, gc_pin: this.gvPinModalData.giftvoucherPin})
          } else {
            this.$store.dispatch('APPLY_GIFT_VOUCHER', {voucher_code: this.giftvouchercode, gc_pin: this.gvPinModalData.giftvoucherPin})
          }
        } else {
          this.$router.push(`/login?redirect=${this.$route.path}`)
        }
      },
      removeVoucher () {
        if (this.callerComp === 'buyNow') {
          this.$store.dispatch('REMOVE_BUYNOW_GIFT_VOUCHER').then((res) => {
          })
        } else {
          this.$store.dispatch('REMOVE_GIFT_VOUCHER')
        }
        this.giftvouchercode = ''
      },
      gvPinUpdate (e) {
        const reg = new RegExp('^[0-9]$')
        if ((!reg.test(e.key)) && !(e.key === 'Backspace' || e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Tab')) {
          e.preventDefault()
          this.gvPinModalData.giftvoucherPin.replace(/[^0-9]/gi, '')
        }
      },
      toggleVoucherPinPopup () {
        this.gvPinModalData.currentModal = null
        this.gvPinModalData.giftvoucherPin = null
        this.callerComp === 'buyNow' ? this.$store.commit('SET_BUYNOW_VOUCHER_LOADING', false) : this.$store.commit('SET_VOUCHER_LOADING', false)
      },
      toasterhandler (msg) {
        Vue.toasted.show(
          msg,
          {
            theme: 'primary',
            className: this.$parent.$parent.isDesktop ? 'toasted-customred' : 'toasted-mobileDefault',
            position: this.$parent.$parent.isDesktop ? 'top-right' : 'bottom-right',
            duration: 4000
          }
        )
      },
      applyVoucherwithPin () {
        if (this.gvPinModalData && this.gvPinModalData.currentModal && this.gvPinModalData.currentModal.length) {
          if (this.gvPinModalData.giftvoucherPin && this.gvPinModalData.giftvoucherPin.length !== this.gvPinModalData.pinMaxLength) {
            this.toasterhandler(`Please Enter ${this.gvPinModalData.pinMaxLength} digit PIN`)
            return false
          } else if ((this.callerComp === 'buyNow' && this.isBuynowVoucherPinAuth && Object.keys(this.isBuynowVoucherPinAuth).length && this.isBuynowVoucherPinAuth.limit_exceed) ||
            (this.voucherPinAuth && Object.keys(this.voucherPinAuth).length && this.voucherPinAuth.limit_exceed)
          ) {
            this.toasterhandler(this.gvPinModalData.pinDefErrorMsg)
            return false
          }
          this.applygiftvoucher()
        }
      }
    },
    computed: {
      ...mapGetters({
        authStatus: 'authStatus',
        giftvoucher: 'gift_voucher',
        buyNow_gift_voucher: 'buyNow_gift_voucher',
        isBuynowVoucherLoading: 'isBuynowVoucherLoading',
        isVoucherLoading: 'isVoucherLoading',
        isBuynowVoucherPinAuth: 'isBuynowVoucherPinAuth',
        voucherPinAuth: 'voucherPinAuth'
      }),
      voucher_applied: function () {
        if (this.callerComp === 'buyNow') {
          return !!(this.buyNow_gift_voucher && this.buyNow_gift_voucher.used_amt)
        } else {
          return !!(this.giftvoucher && this.giftvoucher.used_amt)
        }
      },
      fizzed_out: function () { // CHECK: this is used when the voucher fails to affect the cart
        if (this.callerComp === 'buyNow') {
          return !!(this.buyNow_gift_voucher && this.buyNow_gift_voucher.used_amt === 0)
        } else {
          return !!(this.giftvoucher && this.giftvoucher.used_amt === 0)
        }
      },
      checklogin: function () {
        return true
      }
    },
    creatd () {
      this.giftvoucher = this.callerComp === 'buyNow' ? this.buyNow_gift_voucher : this.giftvoucher
    },
    watch: {
      voucher_applied () {
        this.voucher_applied ? this.toggleVoucherPinPopup() : ''
        if (!this.$parent.$parent.isDesktop) {
          Vue.toasted.show(
            this.voucher_applied ? 'Gift voucher applied successfully.' : 'Gift voucher removed successfully.',
            {
              theme: 'primary',
              className: 'toasted-mobileDefault',
              position: 'bottom-right',
              duration: 2000
            }
          )
        }
      },
      voucherPinAuth () {
        this.gvPinModalData.currentModal = 'popup-modal'
      },
      isBuynowVoucherPinAuth () {
        this.gvPinModalData.currentModal = 'popup-modal'
      }
    }
  }
</script>
<style>

  .vouchers .btn {
    border-radius: 6px;
    color: #117a7a;
  }
  .vouchers .btn:hover {
    background: #117a7a;
    color: #fff;
  }
  .vouchers .voucher-title {
    color: #117a7a;
    margin-bottom: 10px;
  }
  .vouchers .smbox {
    background: none;
    padding: 0 10px;
  }
  @media only screen and (max-width: 480px) {
    .custom-input-parent {
      border: 1px solid rgba(0,0,0,.15);
      border-radius: 3px;
    }
    .custom-input {
      line-height: 30px !important;
      flex-grow:2;
      /* And hide the input's outline, so the form looks like the outline */
      border:none;
    }
    .custom-input:disabled {
      background-color: transparent;
      color: green;
      font-weight: bold;
    }
    .custom-input:focus {
      /* removing the input focus blue box. Put this on the form if you like. */
      outline: none;
    }
    .custom-input::placeholder {
      font-weight: 600;
      -webkit-text-stroke: 0.35px #FFF;
      -webkit-font-smoothing: antialiased;
    }
    .custom-input-btn {
      color: #117a7a;
      font-weight: bold;
    }
    .coupon-spinner{
      width: 25px;
    }
  }
</style>



// WEBPACK FOOTER //
// giftVoucher.vue?d2d8c7a0